import { t } from "i18next"
import colors from "../../styles/colors"
import { typography } from "../../styles/typography"
import { Trans } from "react-i18next"

const Footer = ({ style }) => {

    return (
        <div style={{ ...styles.footer, ...style }}>
            <a style={styles.link} href={'/tos'}>{t("eyearywebhome_11")}</a>
            <a style={styles.link} href={'/privacy_policy'}>{t("eyearywebhome_12")}</a>
            <a style={styles.link} href={'/customer_service'}>{t("eyearywebhome_13")}</a>

            <img src={require("./logo-bg.png")} style={styles.logo} />
            <div style={styles.content}>{t('eyearywebhome_14')} </div>
            <p style={{ ...styles.content, marginTop: 6 }}>
                <Trans i18nKey="eyearywebhome_15">
                    Eyeary and <span style={styles.logoTiny}></span> are trademarks of Edenlux Corp. and may not be used without permission.
                </Trans>

            </p>
            <p style={styles.content}>
                Email: <a style={styles.email} href="mailto:eyeary@edenlx.com">eyeary@edenlx.com</a>
            </p>
        </div>
    )
}

const styles = {
    footer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        borderTop: '1px #181F22 solid',
        padding: '24px 16px 20px'
    },
    link: {
        ...typography.caption_12_regular,
        textDecoration: 'none',
        color: '#fff',
        marginBottom: 6

    },
    logo: {
        height: 36,
        width: 56,
        marginTop: 50,
        marginBottom: 20
    },
    content: {
        ...typography.label_11_regular,
        color: colors.mono300,
    },
    logoTiny: {
        width: 16,
        height: 10,
        margin: '0px 4px',
        display: 'inline-block',
        backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/eyeary-544dd.appspot.com/o/public%2Flogo.png?alt=media&token=399114c6-b56b-463a-b872-a0c7c1d751d0)',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        verticalAlign: 'middle',
    },
    email: {
        color: "#BDF7F7",
        textDecoration: "none"
    }

}

export default Footer